import React, { Component } from 'react';

// Images
import us from '../../img/woman-running.png';
import Button from '../button';
import { Link } from 'react-router-dom';

class QuickAbout extends Component {
   render() {
      return (
         <div className="flex quick-about">
            <div className="justify-center">
               <div className="us container">
                  <div className="row-responsive">
                     <div
                        className="left"
                        style={{ backgroundImage: `url(${us})` }}
                     ></div>
                     <div className="right">
                        <div className="column">
                           <div className="white-space-32"></div>
                           <h1 className="color-secondary quicksand">
                              Expo Médica
                           </h1>
                           <p className="text-justify color-black">
                              Somos una empresa dedicada a la comercialización
                              de artículos médicos y ortopédicos, nuestro
                              personal altamente calificado, le mostrará nuestra
                              amplia gama de productos para proporcionar
                              soluciones para mejorar la movilidad y calidad de
                              vida de nuestros clientes.
                           </p>
                           <div
                              className="justify-end"
                              style={{ marginTop: '10px' }}
                           >
                              <Link to="/nosotros">
                                 <Button theme="soft-red">Conócenos</Button>
                              </Link>
                           </div>
                           <div className="white-space-32"></div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default QuickAbout;



// WEBPACK FOOTER //
// ./src/components/About/quickAbout.js